import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectProjectResources } from 'store/resources/selectors/resources.selectors';
import { setEditRecordDialogAttributes } from '../actions/records.actions';
import { loadResourcesAndResourceEmployersOfProject } from 'store/resources/thunks/loadResourcesAndResourceEmployersOfProject';
import { loadActiveAssignmentsForProject } from 'store/assignments/thunks/loadActiveAssignmentsForProject';

export const handleChangeRecordEditProject = createAsyncThunk(
  'records/handleChangeRecordEditProject',
  async (
    { prevProjectId, newProjectId, prevResourceId },
    { getState, dispatch }
  ) => {
    const prevProjectResources = selectProjectResources(
      getState(),
      prevProjectId
    );

    const prevResource = prevProjectResources.find(
      (resource) => resource.id === prevResourceId
    );

    const newSelectedProjectResources = selectProjectResources(
      getState(),
      newProjectId
    );

    dispatch(loadResourcesAndResourceEmployersOfProject(newProjectId));
    dispatch(loadActiveAssignmentsForProject(newProjectId));

    let resourceIdToSet = undefined;

    if (prevResource) {
      const resourceForSameUserFromNewProjectWithSameEmployer =
        newSelectedProjectResources.find(
          (resource) =>
            resource.user === prevResource.user &&
            resource.employerBusinessId === prevResource.employerBusinessId
        );

      if (resourceForSameUserFromNewProjectWithSameEmployer) {
        resourceIdToSet = resourceForSameUserFromNewProjectWithSameEmployer.id;
      }
    }

    dispatch(
      setEditRecordDialogAttributes({
        project: newProjectId,
        resource: resourceIdToSet,
        assignment: undefined,
      })
    );
  }
);
